<template>
  <l-map
      ref="mapRef"
      style="height: 300px" :zoom="zoom" :center="center" @click="onMapClick"
  >
    <l-tile-layer
        :url="url"
        :attribution="attribution"
    ></l-tile-layer>

    <l-marker :lat-lng="markerPosition" :icon="customIcon">></l-marker>
  </l-map>
</template>

<script>
import {LMap, LTileLayer, LMarker} from "vue2-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";

export default {
  name: "FeatureMapComponent",
  props: {
    productFeature: {},
  },
  components: {
    LMap,
    LTileLayer,
    LMarker,
  },
  data() {
    return {
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution:
          '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      zoom: 50, // Zoom level for the map
      center: [32.4279, 53.6880], // Coordinates of Iran
      markerPosition: [32.4279, 53.6880], // Marker coordinates
      customIcon: new L.Icon({
        iconUrl: "/map_icon.png", // Path to your custom marker icon
        iconSize: [60, 60], // Size of the icon
        iconAnchor: [16, 32], // Point of the icon that will correspond to the marker's location
        popupAnchor: [0, -32], // Position of the popup
      }),

    };
  },
  methods: {
    onMapClick(event) {
      const latLng = event.latlng;
      this.productFeature.feature_value = `${latLng.lat},${latLng.lng}`; // Set marker position to clicked coordinates
      this.markerPosition = [latLng.lat, latLng.lng]; // Set marker position to clicked coordinates
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$refs.mapRef) {
        this.$refs.mapRef.mapObject.invalidateSize();
      }
    });
    this.markerPosition = this.productFeature.feature_value.split(',')
    this.center = this.productFeature.feature_value.split(',')
  }
};
</script>

<style scoped>
#map-wrapper {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
